import React, { useState, useEffect } from "react";
import { MdClose } from "react-icons/md";
import { toast } from "react-toastify"; // Import toast from react-toastify
import SummaryApi from "../../common";

const NotificationModal = ({ isOpen, onClose, notification, onUpdate }) => {
  const [formData, setFormData] = useState({
    title: "",
    details: "",
    is_active: "1",
    posted_by: "",
  });
          
  useEffect(() => {
    if (notification) {
      setFormData({
        title: notification.title || "",
        details: notification.details || "",
        is_active: notification.is_active || "1",
        posted_by: notification.posted_by || "",     
      });
    }
  }, [notification]);                             

  const handleChange = (e) => {
    const { name, value } = e.target;                            
    setFormData({
      ...formData,
      [name]: value,                     
    });      
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!notification || !notification.notification_id) {
      toast.error("Notification ID is missing.");
      return;
    }                                                                                                                                          

    try {
      const response = await fetch(SummaryApi.updateNotification.url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          notification_id: notification.notification_id,
          ...formData,
        }),
      });

      const data = await response.json();

      if (data.status) {
        onUpdate(data.data);
        toast.success("Notification updated successfully!");
        onClose();
      } else {
        toast.error("Failed to update notification.");
      }
    } catch (error) {
      console.error("Error updating notification:", error);
      toast.error("An error occurred while updating notification.");
    }
  };

  const handleCancel = () => {
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg shadow-lg w-96">
        <div className="flex justify-between items-center">
          <h2 className="text-xl font-semibold">Edit Notification</h2>
          <button onClick={onClose}>
            <MdClose size={24} />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="mt-4">
          <div className="mb-4">
            <label
              htmlFor="title"
              className="block text-sm font-medium text-gray-600"
            >
              Title
            </label>
            <input
              type="text"           
              id="title"
              name="title"             
              value={formData.title}
              onChange={handleChange}
              className="w-full p-2 mt-2 border border-gray-300 rounded"
              required
            />
          </div>

          <div className="mb-4">
            <label
              htmlFor="details"
              className="block text-sm font-medium text-gray-600"
            >
              Details
            </label>
            <textarea
              id="details"
              name="details"
              value={formData.details}
              onChange={handleChange}
              className="w-full p-2 mt-2 border border-gray-300 rounded"
              rows="4"
              required
            ></textarea>
          </div>
          <div className="mb-4">
            <label
              htmlFor="posted_by"
              className="block text-sm font-medium text-gray-600"
            >
              Posted By
            </label>
            <input
              type="text"
              id="posted_by"
              name="posted_by"
              value={formData.posted_by}
              onChange={handleChange}
              className="w-full p-2 mt-2 border border-gray-300 rounded"
            />
            </div>
            
          <div className="mb-4">
            <label
              htmlFor="is_active"
              className="block text-sm font-medium text-gray-600"
            >
              Status
            </label>
            <select
              id="is_active"
              name="is_active"
              value={formData.is_active}
              onChange={handleChange}
              className="w-full p-2 mt-2 border border-gray-300 rounded"
            >
              <option value="1">Active</option>
              <option value="0">Inactive</option>
            </select>
          </div>

          <div className="flex justify-between mt-6">
            <button
              type="button"
              onClick={handleCancel}
              className="bg-gray-500 text-white p-2 rounded hover:bg-gray-600"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-orange-600 text-white p-2 rounded hover:bg-orange-700"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NotificationModal;
